import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Transition } from 'react-transition-group';
// import { TweenMax } from 'gsap';

import Background from '../Background';
import Question from './Question';

import style from './index.module.scss';

class Quiz extends Component {
  constructor(props) {
    super(props);

    this.handleAnimateIn = this.handleAnimateIn.bind(this);
    this.handleAnimateOut = this.handleAnimateOut.bind(this);
  }
  handleAnimateIn() {
    if (!this.props.layout.mobile) return;
    // TweenMax.fromTo(this.container, 1, { autoAlpha: 0 }, { autoAlpha: 1 });
  }

  handleAnimateOut() {
    if (!this.props.layout.mobile) return;
  }

  render() {
    const { base: { app }, view: { id }, quiz: { pool, current }, layout: { mobile }, themes } = this.props;
    const show = id === 'quiz';
    const { secondaryColor } = themes[current];

    return (
      <Transition
        timeout={0}
        in={show}
        onExit={() => this.setState(() => ({ active: false }))}
      >
        <div className={`${style.quiz} view ${show ? 'active' : ''}`}
          ref={instance => this.container = instance}
          style={{ color: app.primaryColor, background: secondaryColor }}>
          <div className={style.backgrounds}>
            {/* pool[current].index */}
            {themes.map((theme, index) =>
              <Background show={show && index === current}
                image={themes[index].questionBackground.replace('{{platform}}', mobile ? 'mobile' : 'desktop')}
                skipFade={index === 0}
                index={index}
                fadeback={true}
                key={`background-${index}`} />)}
          </div>
          <div className={style.questions} ref={instance => this.questions = instance}>
            {pool.map((question, index) =>
              <Question question={question} show={show && index === current} index={index}
                primaryColor={app.primaryColor} secondaryColor={secondaryColor}
                onHandleAnimateIn={this.handleAnimateIn}
                onHandleAnimateOut={this.handleAnimateOut} key={`question-${index}`} />)}
          </div>
          <div className={`${style.pagination}`} data-role="pagination">
            {pool.map((question, index) =>
              <div className={`${style.indicator} ${index === current ? style.active : ''}`} style={{ border: `${mobile ? '1' : '2'}px solid ${app.primaryColor}`, background: index === current ? app.secondaryColor : app.primaryColor }} key={`indicator-${index}`}>
                {/* <div className={style.inner} style={{ background: app.secondaryColor }} /> */}
              </div>)}
          </div>
        </div>
      </Transition>
    )
  }
}

const mapStateToProps = state => ({
  view: state.view,
  quiz: state.quiz,
  layout: state.layout,
  themes: state.themes,
  base: state.base
});

export default connect(mapStateToProps)(Quiz);
